<template>
<div id="main" class="column is-9">
			<section class="schedule">
			<div class="columns">
				<div class="column">
					<h1>Contacts</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<div class="columns submissions is-mobile" v-for="contact in contacts" :key="contact.id">
									<div class="column is-10">
										<h4>From: {{ contact.name }}</h4>
										<p> {{ formatDate(contact.date) }}</p>
										<ul>
										<li><span><i class="fa fa-envelope"></i> Email Address: </span><a :href="`mailto:${contact.email}`">{{contact.email}}</a></li>
										<li><span><i class="fa fa-phone"></i> Phone: </span>{{formatPhone(contact.phone)}}</li>
										<li><span><i class="fa fa-reply"></i> Best Way to Contact: </span>{{formatMode(contact.method)}}</li>
										<li><a class="button is-small is-primary" @click="commentModalComment = contact.comments"><i class="fa fa-comment"></i>&nbsp;View Comment</a></li>
										</ul>
									</div>
									<div class="column is-2">
										<a @click="confirmDelete = contact" class="button is-small is-danger is-pulled-right"><i class="fa fa-remove"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</section>
			<Modal v-if="confirmDelete" @close="confirmDelete = null">
				<span slot="title">WARNING</span>
				<p slot="body">Are you sure you want to delete the contact for {{confirmDelete.name}}</p>
				<div slot="footer" class="field is-grouped">
					<div class="control">
						<a class="button is-primary" @click="deleteContact"><i class="fa fa-check"></i></a>
					</div>
					<div class="control">
						<a class="button is-light" @click="confirmDelete = null">Cancel</a>
					</div>
				</div>
			</Modal>
			<Modal v-if="commentModalComment" @close="commentModalComment = null">
				<span slot="title">Comments</span>
				<p slot="body">{{commentModalComment}}</p>
			</Modal>
		</div>
</template>

<script>
	import Modal from "../Modal.vue"
	import moment from "moment-timezone"

	export default {
		components: {
			Modal
		},
		data() {
			return {
				commentModalComment: null,
				confirmDelete: null,
				contacts: []
			}
		},
		methods: {
			formatDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY hh:mm A")
			},
			async deleteContact() {
				await this.$root.$data.setters.deleteContact(this.$root.$data.state, this.confirmDelete.id)
				this.contacts = this.contacts.filter((c) => c.id !== this.confirmDelete.id)
				this.confirmDelete = null
			},
			formatMode(method) {
				if (method === "P") {
					return "Phone"
				} else if (method === "E") {
					return "Email"
				}
			},
			formatPhone(phone) {
				const p = phone.toString()
				return `${p.slice(0,3)}-${p.slice(3,6)}-${p.slice(6)}`
			}
		},
		async created() {
			this.contacts = await this.$root.$data.getters.getContacts(this.$root.$data.state)
		}
	}
</script>